import Widget     from 'lib/widget';
import AjaxFileForm   from "servos/ajaxFileForm"

class AddComplaint extends Widget {
  bind() {
    bindAddComplaint.call(this)
  }
};

const bindAddComplaint = function() {
  const ajaxForm = new AjaxFileForm(this.root)

  ajaxForm.on("success",  successResponse.bind(this))
  ajaxForm.on("error",    errorResponse.bind(this))
}

const successResponse = function(response) {
  window.location.href = window.location.pathname + '?tab=complaints-tab'
}

const errorResponse = function(response) {
  this.replaceHtml(response.jqXHR.responseJSON.formHtml)
}

export default AddComplaint;
